import { useEffect, useState } from "react";
import { Layout, Menu as AntMenu, Input } from "antd";
import { Link } from "react-router-dom";

import { IMAGE_BASE_URL } from "../../constants/api";
import assets from "../../utils/ImagesPath";
import LS_SERVICE from "../../utils/localStorage";
import { getMenuByRole } from "../../constants/constent"; // role-wise menu
import {
  MenuOutlined,
  DashboardOutlined,
  ShopOutlined,
  DollarOutlined,
  SolutionOutlined,
  AppstoreOutlined,
  GlobalOutlined,
  FileProtectOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";

// Icon per menu category (falls back to a generic menu icon)
const CATEGORY_ICONS = {
  Dashboard: <DashboardOutlined />,
  Vendors: <ShopOutlined />,
  "Billing & Finance": <DollarOutlined />,
  "Leads & Enquiries": <SolutionOutlined />,
  Leads: <SolutionOutlined />,
  Masters: <AppstoreOutlined />,
  "Website - Media & Pages": <GlobalOutlined />,
  Logs: <FileProtectOutlined />,
  Administration: <SettingOutlined />,
  Account: <UserOutlined />,
};

const { Sider } = Layout;
const { SubMenu } = AntMenu;

const siderStyle = {
  overflow: "auto",
  height: "95vh",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
};

function Drawer() {
  const [collapsed, setCollapsed] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // All submenus closed by default.
  const [openKeys, setOpenKeys] = useState([]);

  const userType = LS_SERVICE.get("user_type");
  const menuList = getMenuByRole(userType); // role-wise menu

  const { logo, favicon } = LS_SERVICE.get("setting") || {};
  const logoSrc = logo
    ? `${IMAGE_BASE_URL}${collapsed ? favicon : logo}`
    : assets.logo;

  // Filter menu items based on search term
  const filteredMenuCategories = menuList
    .map(({ category, items }) => {
      const filteredItems = items.filter((item) =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase()),
      );

      return { category, items: filteredItems };
    })
    .filter(({ items }) => items.length > 0); // remove empty categories

  // While searching, expand matching categories; when the search is cleared,
  // close everything again (default: all submenus closed).
  useEffect(() => {
    if (searchTerm.trim()) {
      setOpenKeys(filteredMenuCategories.map((cat) => cat.category));
    } else {
      setOpenKeys([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  return (
    <Sider
      width={collapsed ? 80 : 320}
      style={siderStyle}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div style={{ padding: "10px", textAlign: "center" }}>
        <img
          className="logo"
          src={logoSrc}
          alt="Logo"
          style={{ maxWidth: "70%", height: "auto" }}
        />
        {!collapsed && (
          <Input
            placeholder="Search menu"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginTop: 10 }}
          />
        )}
      </div>

      <AntMenu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["dashboard"]}
        openKeys={openKeys}
        onOpenChange={(keys) => setOpenKeys(keys)}
      >
        {filteredMenuCategories.map(({ category, items }) => (
          <SubMenu
            key={category}
            title={category}
            icon={CATEGORY_ICONS[category] || <MenuOutlined />}
          >
            {items.map(({ key, icon, label, to }) => (
              <AntMenu.Item key={key} icon={icon}>
                <Link to={to}>{label}</Link>
              </AntMenu.Item>
            ))}
          </SubMenu>
        ))}
      </AntMenu>
    </Sider>
  );
}

export default Drawer;
